angular.module('rjmNg.controllers').controller('ChartBuilderCtrl', [
  "$scope"
  "$routeParams"
  "Charts"
  "dashboardService"
  "$location"
  "appRoute"
  ($scope, $routeParams, Charts, dashboardService, $location, appRoute) ->

    _goToDashboard = ->
      if $routeParams.dashboardId?
        $location.path(appRoute("/#{$routeParams.dashboardId}")).search("")

    if $routeParams.chartId?
      Charts.getChartData($routeParams.chartId).then (chart)->
        $scope.chart = chart
        dashboardService.setWindowTitle chart.name

    $scope.chart = null
    $scope.isCreate = if $routeParams.chartId? then false else true
    $scope.trendId = 0
    $scope.dashId = if $routeParams.dashboardId? then $routeParams.dashboardId else 0
    $scope.cohortDefault = if +$routeParams.cohortDefault is 1 then true else false

    $scope.$on "closeChartBuilder", _goToDashboard
    $scope.$on "chartOrFigureSaved", _goToDashboard
    $scope.$on "chartOrFigureAdded", _goToDashboard
])
